//import * as currentAccountActions from '../actions/CurrentAccount';

const initialState = {
    orders: [],
}

export const basketCart = (state = initialState, action) => {
    if (!state.initialized) {
        state = { ...initialState, ...state }
    }
    switch(action.type) {
        /*case currentAccountActions.SET_MOD_DOWNLOAD_ACCEPTED:
            return {
                ...state,
                isModDownloadAccepted: true,
            }
        case currentAccountActions.SET_OVERALL_LANGUAGE_FILTER:
            return {
                ...state,
                overallLanguageFilter: action.payload.language,
            }
        case currentAccountActions.SET_IE_ALERT_ACCEPTED:
            return {
                ...state,
                isIEAlertAccepted: true,
            }
        case currentAccountActions.SET_EDGE_ALERT_ACCEPTED:
            return {
                ...state,
                isEdgeAlertAccepted: true,
            }
        case actions.UPDATE_GALLERY_ITEMS:
            return {
                ...state,
                [itemsType]: {
                    ...state[itemsType],
                    isError: false,
                    items: state[itemsType].offset ?
                        concat(state[itemsType].items, action.payload.items) :
                        action.payload.items,
                    //concat(state[itemsType].items, action.payload.items),
                    isFetchedAll: (
                        state[itemsType].offset + GALLERY_ITEMS_PER_PAGE[itemsType] >= action.payload.count
                    ),
                    count: action.payload.count,
                },
            }*/
        default:
            return state
    }
}